import React from 'react'
import Receipt from './Receipt'
// import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Patient from '../../../../../models/Patient/Patient'
import Pathology from '../../../../../models/Pathology/Pathology'
import Immunization from '../../../../../models/Immunization/Immunization'
import ImmunizationRecommendation from '../../../../../models/ImmunizationRecommendion/ImmunizationRecommendation'

class ReceiptContainer extends React.Component {
  getPathologies () {
    const {protocolEntries: entries} = this.props
    const pathologies = []
    if (entries) {
      entries.forEach(entry => {
        pathologies.push(new Pathology(entry.pathology.id, entry.pathology.name, entry.pathology.displayKey, entry.entries))
      })
    }
    return pathologies
  }

  addImmunizations (pathologies, immunizations = []) {
    immunizations.forEach(entry => {
      entry.protoInfo.forEach(info => {
        const {id, date, medicineCode, professional, observations, protoInfo: protocolInfo, type, adverseReactionId} = entry
        pathologies.find(p => p.id === info.pathology.id).addImmunization(new Immunization(id, date, medicineCode, professional, observations, protocolInfo, type, adverseReactionId))
      })
    })
  }

  isRecommendationFulfilled (recommendation, immunizations) {
    let fulfilled = false
    for (let immuno of immunizations) {
      const entry = immuno.protocolInfo.find(info => info.pathology.id === recommendation.pathologyId)
      if (immuno.type !== 'immunoglobulin') {
        fulfilled = entry.pathology.id === recommendation.pathologyId && entry.seqNumber === recommendation.doseNumber
      }
      if (fulfilled) {
        break
      }
    }
    return fulfilled
  }

  addRecommendations (pathologies, recommendations = []) {
    recommendations.forEach(recom => {
      const pathology = pathologies.find(p => p.id === recom.pathologyId)
      if (pathology && !this.isRecommendationFulfilled(recom, pathology.immunizations)) {
        const {id, date, vaccineCode, pathologyId, doseNumber, status, dateCriterion} = recom
        pathology.addRecommendation(new ImmunizationRecommendation(id, date, vaccineCode, pathologyId, doseNumber, status, dateCriterion))
      }
    })
  }

  isPlannedShotFulfilled (pathologyId, shot, immunizations) {
    let fulfilled = false
    for (let immuno of immunizations) {
      const entry = immuno.protocolInfo.find(info => info.pathology.id === pathologyId)
      fulfilled = entry.pathology.id === pathologyId && entry.seqNumber === shot.sequenceNumber
      if (fulfilled) {
        break
      }
    }
    return fulfilled
  }

  isPlannedShotRecommended (pathologyId, shot, recommendations) {
    let fulfilled = false
    for (let recom of recommendations) {
      fulfilled = shot.sequenceNumber === recom.doseNumber
      if (fulfilled) {
        break
      }
    }
    return fulfilled
  }

  addPlannedShots (pathologies) {
    pathologies.forEach(pathology => {
      pathology.entries.forEach(entry => {
        if (!this.isPlannedShotFulfilled(pathology.id, entry, pathology.immunizations) &&
          !this.isPlannedShotRecommended(pathology.id, entry, pathology.recommendations)) {
          const {seqNumber, val, unit} = entry
          pathology.addPlannedShot({seqNumber, val, unit})
        }
      })
    })
  }

  getNextImmunizations (pathologies) {
    const arr = []
    const recommendations = []
    const dates = new Set()
    pathologies.forEach(pathology => {
      pathology.recommendations.forEach(recommendation => {
        recommendations.push(recommendation)
        dates.add(recommendation.dateCriterion.recommended)
      })
    })
    dates.forEach(date => {
      const forThisDate = recommendations.filter(rec => rec.dateCriterion.recommended === date)
      const _pathologies = []
      forThisDate.forEach(entry => {
        const pathology = pathologies.find(p => p.id === entry.pathologyId)
        _pathologies.push(pathology.displayKey)
      })
      arr.push({
        date: date,
        pathologies: _pathologies
      })
    })
    return arr
  }

  render () {
    const {
      immunizations,
      recommendations,
      protocolEntries,
      currentLocale
    } = this.props
    const pathologies = this.getPathologies(protocolEntries)
    if (pathologies.length > 0) {
      this.addImmunizations(pathologies, immunizations)
      this.addRecommendations(pathologies, recommendations)
      this.addPlannedShots(pathologies)
    }
    const {id, name, birthDate, gender, photo, country} = this.props.patientData
    const patient = new Patient(id, name, birthDate, gender, photo, country)
    const nextImmunizations = this.getNextImmunizations(pathologies)
    return <Receipt
      currentLocale={currentLocale}
      pathologies={pathologies}
      nextImmunizations={nextImmunizations}
      patient={patient} />
  }
}

// function mapDispatchToProps (dispatch) {
//   return bindActionCreators({}, dispatch)
// }

function mapStateToProps ({patient, plan, recommendations, immunizations, polyglot}) {
  return {
    protocolEntries: plan.protocolEntries,
    immunizations,
    recommendations,
    patientData: patient.data,
    currentLocale: polyglot.locale
  }
}

export default connect(mapStateToProps)(ReceiptContainer)
